import(/* webpackMode: "eager" */ "/app/src/app/(main)/dang-ky-hoc-guitar/page.tsx");
